// extracted by mini-css-extract-plugin
export default {"root":"AddMenteeModuleButton_root__RJSO7"};